export const setLocalStorage = (storageName: string, value: string) => {
  localStorage.setItem(storageName, value);
};

export const getLocalStorage = (storageName: string) => {
  const value = localStorage.getItem(storageName);
  return value !== null ? value : "";
};
